import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

// Shows the user's avatar as nav-bar button in the native app; a tap follows the real link to the account screen.
export default class extends BridgeComponent {
  static component = "avatar"

  connect() {
    super.connect()

    const title = this.bridgeElement.title
    const imageUrl = this.bridgeElement.bridgeAttribute("image-url")
    this.send("connect", { title, imageUrl }, () => this.bridgeElement.click())
  }
}
